const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://offersshopping.com';

export default function HomeSeoJsonLd() {
  const store = {
    '@context': 'https://schema.org',
    '@type': 'Store',
    name: 'Digital Licence Store',
    url: SITE_URL,
    logo: `${SITE_URL}/logo.png`,
    description: 'Tienda online de licencias de software originales: Windows, Microsoft Office, Antivirus y VPN con los mejores precios en Colombia.',
    telephone: '+79534940353',
    email: 'DigitalLicenceStore@offersshopping.com',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'CO',
    },
    priceRange: '$$',
    currenciesAccepted: 'COP, USD, EUR',
    paymentAccepted: 'PayPal, MercadoPago, Transferencia bancaria',
    openingHours: 'Mo-Su 00:00-23:59',
    hasMap: '',
    sameAs: [
      'https://wa.me/79534940353',
      'https://t.me/Sup0rteWin',
    ],
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.9',
      reviewCount: '847',
      bestRating: '5',
      worstRating: '1',
    },
  };

  const itemList = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Licencias de Software Originales - Digital Licence Store',
    description: 'Catálogo completo de licencias originales de Windows, Office, Antivirus y VPN',
    url: SITE_URL,
    numberOfItems: 4,
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Licencias Windows',
        url: `${SITE_URL}/windows`,
        description: 'Licencias originales Windows 10 PRO y Windows 11 PRO/HOME desde $55.385 COP',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Licencias Microsoft Office',
        url: `${SITE_URL}/office`,
        description: 'Licencias originales Office 2021, 2024 y Office 365 con descuentos hasta 75%',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'Antivirus',
        url: `${SITE_URL}/antivirus`,
        description: 'Kaspersky, McAfee y ESET NOD32 con descuentos hasta 58%',
      },
      {
        '@type': 'ListItem',
        position: 4,
        name: 'VPN AdGuard',
        url: `${SITE_URL}/vpn`,
        description: 'AdGuard VPN con hasta 77% de descuento para 1, 5 y 10 dispositivos',
      },
    ],
  };

  const breadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Inicio',
        item: SITE_URL,
      },
    ],
  };

  const website = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Digital Licence Store',
    url: SITE_URL,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${SITE_URL}/?search={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(store) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(itemList) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumb) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(website) }}
      />
    </>
  );
}
